import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Grid } from "@mui/material";

import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

import { totalPrice } from "../../utils";
import {
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
} from "../../store/actions/action";

// 🧾 Types
export interface CartItem {
  id: number | string;
  title: string;
  price: number;
  qty: number;
  size?: string;
  brand?: string;
  proImg?: string;
}

interface CartPageProps {
  carts: CartItem[];
  removeFromCart: (id: number | string) => void;
  incrementQuantity: (id: number | string) => void;
  decrementQuantity: (id: number | string) => void;
}

const CartPage: React.FC<CartPageProps> = ({
  carts,
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
}) => {
  const ClickHandler = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Fragment>
      <Navbar hclass="wpo-header-style-1" />
      <PageTitle pageTitle="Cart" pagesub="Cart" />

      <div className="cart-area section-padding">
        <div className="container">
          <div className="form">
            <div className="cart-wrapper">
              <div className="row">
                <div className="col-12">
                  <form>
                    <table className="table-responsive cart-wrap">
                      <thead>
                        <tr>
                          <th className="images">Image</th>
                          <th className="product-2">Product Name</th>
                          <th className="pr">Quantity</th>
                          <th className="price">Price</th>
                          <th className="stock">Total Price</th>
                          <th className="remove">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {carts?.length > 0 ? (
                          carts.map((item, index) => (
                            <tr key={index}>
                              <td className="images">
                                {item.proImg && (
                                  <img src={item.proImg} alt={item.title} />
                                )}
                              </td>

                              <td className="product">
                                <ul>
                                  <li className="first-cart">{item.title}</li>
                                  {item.brand && <li>Brand: {item.brand}</li>}
                                  {item.size && <li>Size: {item.size}</li>}
                                </ul>
                              </td>

                              <td className="stock">
                                <div className="pro-single-btn">
                                  <Grid className="quantity cart-plus-minus">
                                    <Button
                                      className="dec qtybutton"
                                      onClick={() => decrementQuantity(item.id)}
                                    >
                                      -
                                    </Button>
                                    <input
                                      value={item.qty}
                                      type="text"
                                      readOnly
                                    />
                                    <Button
                                      className="inc qtybutton"
                                      onClick={() => incrementQuantity(item.id)}
                                    >
                                      +
                                    </Button>
                                  </Grid>
                                </div>
                              </td>

                              <td className="price">${item.price}</td>
                              <td className="stock">
                                ${(item.price * item.qty).toFixed(2)}
                              </td>

                              <td className="action">
                                <ul>
                                  <li
                                    className="w-btn"
                                    onClick={() => removeFromCart(item.id)}
                                  >
                                    <i className="fi ti-trash"></i>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={6} style={{ textAlign: "center" }}>
                              Your cart is empty 🛒
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </form>

                  <div className="submit-btn-area">
                    <ul>
                      <li>
                        <Link
                          onClick={ClickHandler}
                          className="theme-btn"
                          to="/shop"
                        >
                          Continue Shopping
                        </Link>
                      </li>
                      <li>
                        <button type="submit">Update Cart</button>
                      </li>
                    </ul>
                  </div>

                  <div className="cart-product-list">
                    <ul>
                      <li>
                        Total Products<span>( {carts.length} )</span>
                      </li>
                      <li>
                        Sub Price<span>${totalPrice(carts).toFixed(2)}</span>
                      </li>
                      <li>
                        VAT<span>$0.00</span>
                      </li>
                      <li>
                        Eco Tax<span>$0.00</span>
                      </li>
                      <li>
                        Delivery Charge<span>$0.00</span>
                      </li>
                      <li className="cart-b">
                        Total Price
                        <span>${totalPrice(carts).toFixed(2)}</span>
                      </li>
                    </ul>
                  </div>

                  <div className="submit-btn-area">
                    <ul>
                      <li>
                        <Link
                          onClick={ClickHandler}
                          className="theme-btn"
                          to="/checkout"
                        >
                          Proceed to Checkout
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer footerClass="wpo-site-footer-s1" />
      <Scrollbar />
    </Fragment>
  );
};

const mapStateToProps = (state: any) => ({
  carts: state.cartList.cart,
});

export default connect(mapStateToProps, {
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
})(CartPage);
